import { DialogMaster } from "#core/components/dialog/Dialog"
import { useApiSend } from "#hooks/useApiSend"
import { useRefresh } from "#vacancy/redux/actions"
import { vacancyIdPut } from "#vacancy/services/api"
import { useCallback, useState } from "react"

export default function VacancyDialogStatus({
	open,
	setOpen,
	vacanteId,
	status,
	children,
	reason = null,
	title,
	validation,
	...moreData
}) {
	const { refresh } = useRefresh()
	const [disabled, setDisabled] = useState(false)

	const success = () => {
		setOpen(false)
		refresh()
	}

	const end = () => {
		setDisabled(false)
	}

	const { fetch } = useApiSend(vacancyIdPut, { success, end })

	const handleSubmit = useCallback(() => {
		const sendData = { status, reason, ...moreData }
		if (validation && typeof validation === "function") if (!validation(sendData)) return

		setDisabled(true)
		fetch(vacanteId, sendData)
	}, [fetch, moreData, reason, status, vacanteId, validation])

	return (
		<DialogMaster {...{ open, setOpen, title, maxWidth: "sm", handleSubmit, disabled }}>
			{children}
		</DialogMaster>
	)
}
